<ng-container *transloco="let convert;">
  @if (showHeading) {
    <h3 class="text-uppercase fw-bold h5">{{convert('sellModule.details.sellerLocation.sellerAndLocation')}}</h3>
  }
  @if (location$ | async; as location) {
    <section class="vehicle-location" [class.mb-5]="showHeading">
      <p
        class="vehicle-location__seller-name m-0 fw-bold"
        [attr.aria-label]="convert('sellModule.details.sellerLocation.ariaLabelSellerName') + location.sellerName"
        >
        {{ location.sellerName }}
      </p>
      @if (!location.sellerName || location.sellerName === '') {
        <p
          class="vehicle-location__seller-name m-0 fw-bold"
          >
          N/A
        </p>
      }
      <div class="vehicle-location__storage mt-3">
        <p class="vehicle-location__storage--title text-uppercase fw-bold mb-1">{{convert('sellModule.details.sellerLocation.vehicleLocation')}}</p>
        <div class="vehicle-location__storage--info">
          @if (
            !location.name &&
            !location.addressLine1 &&
            !location.city &&
            !location.city &&
            !location.state &&
            !location.zip
            ) {
            <p
              class="mb-0"
              >
              N/A
            </p>
          }
          @if (location.name) {
            <p class="mb-0">{{ location.name }}</p>
          }
          @if (location.addressLine1) {
            <p class="mb-0">{{ location.addressLine1 }}</p>
          }
          @if (location.addressLine2) {
            <p class="mb-0">{{ location.addressLine2 }}</p>
          }
          @if (location.city) {
            <p class="mb-0 d-inline-block">
              {{ location.city }}
              @if (location.city) {
                ,
              }
              &nbsp;
            </p>
          }
          @if (location.state) {
            <p class="mb-0 d-inline-block">{{ location.state }} &nbsp;</p>
          }
          @if (location.zip) {
            <p class="mb-0 d-inline-block">{{ location.zip }}</p>
          }
        </div>
      </div>
    </section>
  }
</ng-container>
